import { all, put, call, fork, take } from "redux-saga/effects";
import * as api from "../../utils/api";
import { orgaActions, GET_COLUMNS_REQUEST, GET_ORGA_TASKS_REQUEST, SILENT_TASKS_UPDATE } from "./actions";

export function* asyncGetColumns({ payload, resolve, reject }) {
  try {
    const columnsRes = yield call(api.getOrgaColumns);
    if (columnsRes.status === 200 && columnsRes.data) {
      yield put(orgaActions.getColumnsSuccess(columnsRes.data));
    }
    resolve(columnsRes.data);
  } catch (err) {
    reject(err);
  }
}

export function* asyncGetTasks({ payload, resolve, reject }) {
  try {
    const tasksRes = yield call(api.getOrgaTasks);
    if (tasksRes.status === 200 && tasksRes.data) {
      yield put(orgaActions.getTasksSuccess(tasksRes.data));
    }
    resolve(tasksRes.data);
  } catch (err) {
    reject(err);
  }
}
export function* asyncSilentTaskUpdate({ payload, resolve, reject }) {
  try {
    const updateRes = yield call(api.updateOrgaTask, payload);
    if (updateRes.status !== 200) {
      //todo better error handling
      yield put(orgaActions.getTasks());
    }
  } catch (err) {
    reject(err);
  }
}

export function* watchGetColumns() {
  while (true) {
    const action = yield take(GET_COLUMNS_REQUEST);
    yield* asyncGetColumns(action);
  }
}
export function* watchGetTasks() {
  while (true) {
    const action = yield take(GET_ORGA_TASKS_REQUEST);
    yield* asyncGetTasks(action);
  }
}
export function* watchSilentUpdate() {
  while (true) {
    const action = yield take(SILENT_TASKS_UPDATE);
    yield* asyncSilentTaskUpdate(action);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function* () {
  yield all([fork(watchGetColumns), fork(watchGetTasks), fork(watchSilentUpdate)]);
}
